var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"pl-2 border-gray-300 focus:border-green-500 rounded-md focus:ring-green-200 focus:ring-opacity-5 shadow-sm",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }